<template>
  <div class="shopper-help-page" data-testid="shopper-help-page">
    <help-renderer audience="shopper" base-path="/help/shopper" />
  </div>
</template>

<script>
/**
 * Shopper help surface -- mounted at `/help/shopper[/:slug]` on the
 * storefront surface (`docs/user/HELP-SYSTEM-DESIGN.md` decision 4).
 *
 * PUBLIC. This route MUST NOT require a distributor login: a shopper
 * reading "how do I place an order" is by definition not signed into the
 * distributor app. The path is allowlisted in `router/requireToken.js`
 * (`/help/shopper` exact + `/help/shopper/` prefix) and the boundary is
 * locked by `router/__tests__/help-routes-auth-boundary.spec.js`.
 *
 * The path is NOT slug-scoped to a store, unlike the `/shop/:slug/*`
 * session tree: help content is the same team-authored product
 * documentation for every store, so scoping it per-store would imply a
 * per-store variation that does not exist.
 *
 * Same thin-wrapper shape as OwnerHelpPage -- only the audience differs.
 */
import HelpRenderer from "@/components/Help/HelpRenderer.vue";

export default {
  name: "ShopperHelpPage",
  components: { HelpRenderer },
};
</script>
